'use strict';

function parse(reader) {
    reader.readUInt8("version");
    let count = (reader.getLength() - 5) / 7;
    for (let i = 1; i <= count; i++) {
        reader.readUInt8(`data.ip_${i}.ip_address.1`);
        reader.readUInt8(`data.ip_${i}.ip_address.2`);
        reader.readUInt8(`data.ip_${i}.ip_address.3`);
        reader.readUInt8(`data.ip_${i}.ip_address.4`);
        reader.readUInt16LE(`data.ip_${i}.port`);
        reader.readUInt8(`data.ip_${i}.connected`, value => value === 1);
    }
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/uart/dtu-report-parser.js